import type { PrivacyTranslation } from './types';

/** Arabic (Modern Standard). Pending review by native speakers, as the note in the interface says. */
export const privacyAr: PrivacyTranslation = {
  nav: 'الخصوصية',
  title: 'الخصوصية',
  description: 'مدة احتفاظ مساحة العمل بالمحادثات، وما يمكنك فعله حين يطلب عميل بياناته أو محوها.',
  retention: {
    title: 'مدة الاحتفاظ بالمحادثات',
    description:
      'تُحذف المحادثات المحلولة التي مضى على آخر رسالة فيها أكثر من هذه المدة من Chatwoot ومن Hamnivo مع ملفاتها. ويُحذف أيضًا العملاء الذين لم تبق لهم أي محادثة. وتبقى أرقام التقارير كما هي.',
    guide: 'كيف تعمل مدة الاحتفاظ',
    loading: 'جارٍ تحميل مدة الاحتفاظ بالمحادثات',
    label: 'الاحتفاظ بالمحادثات المحلولة',
    hint: 'تُحسب المدة من آخر رسالة. والمحادثة التي يكتب فيها العميل من جديد تبقى.',
    forever: 'حتى تُحذف يدويًا',
    periods: {
      d90: '3 أشهر',
      d180: '6 أشهر',
      d365: 'سنة واحدة',
      d730: 'سنتان',
      d1095: '3 سنوات',
      d1825: '5 سنوات',
      d2555: '7 سنوات',
    },
    counting: 'جارٍ عدّ المحادثات…',
    preview: 'المحادثات المحلولة الأقدم من هذه المدة اليوم: {{n}}.',
    startsOn:
      'يبدأ الحذف في {{date}}، بعد أسبوع من الحفظ، ليبقى التراجع ممكنًا. ويصل بريد إلكتروني بذلك إلى كل مالك.',
    atOnce: 'هذا لا يُسرّع حذف أي شيء، لذا يسري فورًا.',
    save: 'حفظ',
    saved: 'تم الحفظ.',
    pending:
      'ابتداءً من {{date}} ستُحذف المحادثات المحلولة الأقدم من {{period}}. ويمكنك التراجع حتى ذلك الحين.',
    undo: 'تراجع',
    undone: 'تم التراجع. لن يُحذف أكثر مما كان يُحذف من قبل.',
    progress: 'حُذف حتى الآن: {{conversations}} محادثة و{{customers}} عميل.',
    checked: 'آخر فحص {{date}}.',
    running: 'جارٍ حذف المحادثات القديمة. قد تستغرق المرة الأولى بعض الوقت.',
    blocked:
      'توقف الحذف: لم يسمح Chatwoot لـ Hamnivo بحذف المحادثات. يجب أن يكون مستخدم Chatwoot الذي يتصل به Hamnivo مسؤولًا. ولم يُحذف شيء في Hamnivo أيضًا. ويُستأنف الحذف تلقائيًا بعد إصلاح ذلك.',
    kept: 'تبقى الطلبات والمدفوعات وسجل التدقيق، فهي سجلات تجارية.',
  },
  customers: {
    title: 'بيانات عميل',
    description: 'ابحث عن عميل لتنزيل كل ما يخصه، أو لمحوه من كل مكان، بما في ذلك Chatwoot.',
    guide: 'التنزيل والمحو',
    search: 'البحث عن عميل',
    searchHint:
      'الاسم أو البريد الإلكتروني أو رقم الهاتف أو معرّفه في أنظمتك، أو معرّف عميل أو محادثة. حرفان على الأقل.',
    find: 'بحث',
    searching: 'جارٍ البحث عن العملاء',
    none: 'لا يوجد عميل يطابق «{{query}}».',
    results: 'العملاء الذين وُجدوا',
    unnamed: 'زائر بلا اسم',
    erased: 'محوّ',
    lastSeen: 'آخر ظهور {{date}}',
    loading: 'جارٍ تحميل العميل',
    id: 'معرّف العميل',
    brand: 'العلامة التجارية',
    conversations: 'المحادثات',
    orders: 'الطلبات',
    memories: 'الذكريات',
    shared:
      'لجهة اتصاله في Chatwoot محادثات لعلامة تجارية أخرى أيضًا. تبقى تلك المحادثات وجهة الاتصال.',
    ordersKept: 'تبقى طلباته سجلاتٍ تجارية، بلا اسمه ولا تفاصيل التوصيل.',
    erasedNote: 'مُحي هذا العميل. لم يبقَ إلا سجل مجهول الهوية لأن طلباته تشير إليه.',
    close: 'إغلاق',
    download: 'تنزيل بياناته',
    erase: 'محو هذا العميل',
    exportStarted: 'جارٍ تجهيز الملف. سيظهر في الطلبات عندما يجهز.',
    eraseStarted: 'بدأ المحو. سيظهر في الطلبات عند انتهائه.',
    reason: {
      label: 'السبب',
      access_request: 'طلب الاطلاع على بياناته',
      erasure_request: 'طلب محو بياناته',
      other: 'سبب آخر',
    },
    reference: 'المرجع (اختياري)',
    referenceHint: 'رقم التذكرة أو الحالة لديك. لا تكتب فيه تفاصيل شخصية.',
    exportTitle: 'تنزيل بيانات {{name}}',
    exportBody:
      'يضم الملف ملفه الشخصي، ومحادثاته كما رآها، والملفات المرسلة في الاتجاهين، والموافقات، والذاكرة، والطلبات، والتقييمات. تُستبعد الملاحظات الداخلية. يمكنك تنزيله خلال 24 ساعة، ويُسجَّل كل تنزيل.',
    exportSubmit: 'تجهيز الملف',
    eraseTitle: 'محو {{name}}',
    eraseBody:
      'يحذف هذا محادثاته وجهة اتصاله في Chatwoot، وكل ما يخصه في Hamnivo: الملف الشخصي والمحادثات والملفات والذاكرة والتقييمات والتفضيلات. لا يمكن التراجع عنه.',
    eraseKept:
      'يبقى: الطلبات والمدفوعات بلا اسمه ولا تفاصيل التوصيل، وسجلات الموافقة، وسجل التدقيق.',
    confirm: 'اكتب معرّف العميل للتأكيد: {{id}}',
    confirmMismatch: 'اكتب معرّف العميل كما يظهر تمامًا.',
    eraseSubmit: 'المحو من كل مكان',
  },
  requests: {
    title: 'الطلبات',
    description: 'عمليات التصدير والمحو، الأحدث أولًا.',
    loading: 'جارٍ تحميل الطلبات',
    empty: 'لا توجد عمليات تصدير أو محو بعد.',
    kind: { export: 'تصدير', erase: 'محو' },
    state: {
      queued: 'في الانتظار',
      running: 'قيد التنفيذ',
      completed: 'تم',
      blocked: 'متوقف',
      failed: 'فشل',
    },
    by: 'بواسطة {{name}}',
    download: 'تنزيل',
    until: 'حتى {{date}}',
    gone: 'حُذف بعد 24 ساعة',
    exported: 'المحادثات: {{conversations}}، الملفات: {{files}}',
    erasedCounts: 'حُذفت محادثات: {{conversations}}، وجهات اتصال في Chatwoot: {{contacts}}',
    blocked:
      'لم يسمح Chatwoot لـ Hamnivo بالحذف. يجب أن يكون مستخدم Chatwoot الذي يتصل به Hamnivo مسؤولًا. لم يُحذف شيء في Hamnivo. اطلب مرة أخرى بعد إصلاح ذلك.',
    failed: 'لم يكتمل. اطلب مرة أخرى.',
  },
};
